import { useEffect } from "react";

import {
  Column,
  ErrorText,
  LoadingIndicator,
  TopbarContainer,
  TopbarTitle,
} from "@/components";
import { SadieVoiceCallsTable } from "@/components/tools/sadie-voice-calls/SadieVoiceCallsTable";

import { useGetSadieCalls } from "@/hooks/queries/useGetSadieCalls";
import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const ToolsSadieVoiceCallsPage = () => {
  /* Database CRUD Operations */
  // Read
  const { data: calls, status } = useGetSadieCalls();

  /* React Hooks */
  useSetTitle({ title: "Tools | Sadie Voice Calls" });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.SADIE_VOICE_CALLS);
  }, []);

  /* Render */
  const render = () => {
    if (status === "pending") return <LoadingIndicator variant="medium" />;
    if (status === "error")
      return <ErrorText errorMessage="Error loading Sadie voice calls." />;
    return <SadieVoiceCallsTable calls={calls} />;
  };

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Sadie Voice Calls</TopbarTitle>
      </TopbarContainer>
      <Column className="flex-1 overflow-hidden p-6">{render()}</Column>
    </Column>
  );
};
